import { ActivatedRouteSnapshot, CanDeactivateFn, Router } from '@angular/router';
import { CreateProjectPage } from '../../features/client/projects/create-project/create-project.page';
import { ProjectCreatorService } from '../../features/client/services/project-creator.service';
import { inject } from '@angular/core';

export const canLeaveProjectGuard: CanDeactivateFn<CreateProjectPage> = async (
  component: CreateProjectPage,
  currentRoute: ActivatedRouteSnapshot,
) => {
  const currentProjectId = currentRoute.params['projectId'] || currentRoute.queryParams['projectId'];
  const editProjectProductId = currentRoute.queryParams['editProjectProductId'];
  const router = inject(Router);
  const nextUrl = router.getCurrentNavigation()?.finalUrl?.toString();

  // Allow navigation to checkout/cart without confirmation
  if (nextUrl?.includes('/checkout')) {
    return true;
  }

  // If project already saved (has ID) or in edit mode, allow navigation without confirmation
  if (currentProjectId || editProjectProductId) {
    return true;
  }

  const projectCreatorService = (component as any).projectCreatorService as ProjectCreatorService;
  if (projectCreatorService && !projectCreatorService.canLeaveProject()) {
    const result = await component.openLeaveModal();
    return !!result?.confirmed;
  }

  return true;
};
